import { AntiSpamFields } from "../../../../interfaces/main";
import { axiosInstance } from "../../axiosConfig";

export default async function sendPasswordResetVerifyCode(
  email: string,
  antiSpamPayload?: AntiSpamFields
) {
  try {
    const { data } = await axiosInstance.post("/forgot_password/verification_code", {
      email: email,
      ...antiSpamPayload,
    });
    return data;
  } catch (err) {
    throw err;
  }
}
